import { useEffect, useState } from 'react'

/**
 * Bounds an "infinite skeleton" state. `active` is typically a react-query
 * `isLoading`/`isFetching` flag. Once `active` has stayed true continuously
 * for `ms`, `timedOut` flips to true so the caller can fall back to an
 * honest "this is taking longer than expected" / retry state instead of a
 * spinner that never resolves.
 *
 * Resets to false as soon as `active` goes false (the query settled, either
 * to success or error) so a subsequent load/refetch gets its own fresh
 * timeout window.
 */
export function useTimedOut(active: boolean, ms = 8000): boolean {
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (!active) {
      setTimedOut(false)
      return
    }
    const timer = setTimeout(() => setTimedOut(true), ms)
    return () => clearTimeout(timer)
  }, [active, ms])

  return timedOut
}
